import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { PAGE_WIDTH } from '../utils';

export const ConnectingContent = () => {
  return (
    <ChakraV3.Flex flexDir='column' h='full' w='full' maxW={PAGE_WIDTH} px={6} alignSelf='center'>
      <ChakraV3.Stack w='full' mt={2} gap={4}>
        <ChakraV3.HStack>
          <ChakraV3.SkeletonText noOfLines={1} h='32px' w='460px' />
          <ChakraV3.Spacer />
          <ChakraV3.SkeletonCircle size='28px' />
          <ChakraV3.Box w='10px' />
        </ChakraV3.HStack>
        <ChakraV3.SkeletonText noOfLines={1} h='28px' />
        <ChakraV3.SkeletonText noOfLines={4} gap={4} h='8px' w='xs' />
      </ChakraV3.Stack>
    </ChakraV3.Flex>
  );
};
